import React from 'react';
import { Link } from 'react-router-dom';

export default function Breadcrumb({ title, crumbs }) {
  return (
    <section className="breadcrumb-section">
      <div className="container">
        <div className="breadcrumb-content">
          <h2>{title}</h2>
          <nav className="breadcrumb-nav" aria-label="Breadcrumb">
            {crumbs.map((c, i) => (
              <React.Fragment key={i}>
                {i > 0 && <span className="breadcrumb-separator"><i className="fas fa-chevron-right"></i></span>}
                {c.link ? <Link to={c.link}>{c.label}</Link> : <span>{c.label}</span>}
              </React.Fragment>
            ))}
          </nav>
        </div>
      </div>
    </section>
  );
}
